"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(module.exports, "babelPluginFlowReactPropTypes_proptype_Broadcast", {
  value: require("react").PropTypes.shape({
    publish: require("react").PropTypes.func.isRequired,
    subscribe: require("react").PropTypes.func.isRequired
  })
});
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialValue) {
  var listeners = [];
  var currentValue = initialValue;

  return {
    publish: function publish(value) {
      currentValue = value;
      listeners.forEach(function (listener) {
        return listener(currentValue);
      });
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);

      // Publish to this subscriber once immediately.
      listener(currentValue);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    }
  };
};

exports.default = createBroadcast;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/create-broadcast.js
// module id = 102
// module chunks = 0